import { render, staticRenderFns } from "./GuestDetail.vue?vue&type=template&id=2400354e&"
import script from "./GuestDetail.vue?vue&type=script&lang=js&"
export * from "./GuestDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports